import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

/**
 * Status badge component for devices
 */
const DeviceStatusBadge = ({ status }) => {
  const { t } = useTranslation();

  const getStatusConfig = (s) => {
    const statusString = String(s || '').toLowerCase();
    switch (statusString) {
      case 'online':
        return { classes: 'bg-green-100 text-green-800', text: t('common.status.online') };
      case 'offline':
        return { classes: 'bg-gray-100 text-gray-800', text: t('common.status.offline') };
      case 'error':
        return { classes: 'bg-red-100 text-red-800', text: t('common.status.error') };
      case 'warning':
        return { classes: 'bg-yellow-100 text-yellow-800', text: t('devices.status.warning') };
      case 'provisioning':
        return { classes: 'bg-blue-100 text-blue-800', text: t('devices.status.provisioning') };
      case 'unknown':
      default:
        return { classes: 'bg-gray-50 text-gray-600', text: t('managedDevices.filters.statusUnknown') };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={clsx(
      'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium capitalize',
      config.classes
    )}>
      {config.text}
    </span>
  );
};

export default DeviceStatusBadge;
